/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react'
import {
  Button,
  Form,
  List
} from 'semantic-ui-react'
import { format } from 'date-fns'
import { connect } from 'react-redux'
// Local
import {
  CONDITION,
  FORMAT,
  NOTE,
  ROLES,
  shouldRenderReskin2025
} from '../../../constant'
import {
  EncounterConditionDisplay,
  User
} from '../../authenticated/types'
import If from '../../common/if'
import ReveleerButton from '../../common/ReveleerButton'
import { ObjectValues } from '../../../types/types'
import { RootState } from '../../../store'

const mapStateToProps = (state: RootState) => ({
  currentUser: state.user
})

type ReduxStateProps = ReturnType<typeof mapStateToProps>

type Props = ReduxStateProps & {
  condition: EncounterConditionDisplay
  onSubmit: (
    condition: EncounterConditionDisplay,
    note: string,
    noteReasonCode: ObjectValues<typeof NOTE.REASON>
  ) => void
  userRole: ObjectValues<typeof ROLES>
}

function ConditionNotes(props: Props) {
  const {
    condition,
    // eslint-disable-next-line no-unused-vars
    currentUser,
    onSubmit,
    userRole
  } = props

  const [
    note,
    setNote
  ] = useState<string>('')

  const onSubmitComment = (): void => {
    onSubmit(
      condition,
      note,
      NOTE.REASON.OPEN
    )
  }

  const onSubmitQuery = (): void => {
    onSubmit(
      condition,
      note,
      NOTE.REASON.CODER_QUERY
    )
  }

  const shouldShowCoderActions = userRole === ROLES.CODER
  const shouldShowCdiActions = userRole === ROLES.CDI

  const shouldShowOnlyCommentButton = (
    condition.addressedDate ||
    condition.conditionStatus === CONDITION.TYPE.ACTIVITY
  )

  const shouldShowCommentAndQueryButtons = (
    (
      condition.conditionStatus === CONDITION.TYPE.KNOWN ||
      condition.conditionStatus === CONDITION.TYPE.POTENTIAL
    ) &&
    condition.addressedDate === null
  )

  return (
    <div>
      <div className="condition-notes">
        { condition.notes &&
          condition.notes.map(conditionNote => (
            <List.Item key={ conditionNote.id }>
              { conditionNote.noteReasonCode === NOTE.REASON.CODER_QUERY && (
                <span className="bold">Query: </span>
              ) }
              <span className="italic">
                &quot;{ conditionNote.noteBody }&quot;
              </span>
              <span> -</span>
              <span> { conditionNote.createdByUserName }</span>
              <span>
                { ' ' }
                ({ format(conditionNote.creationDate, FORMAT.DATE_TIME) })
              </span>
            </List.Item>
          )) }
      </div>
      <Form.TextArea
        name="note"
        value={ note }
        className="condition-notes-textarea"
        placeholder="Condition Notes: Only viewable by CDI and Coders. Coders please include query here."
        onChange={ (event: any, noteValue: any) => {
          setNote(noteValue.value as string)
        } }
      />
      <If isTrue={ !!note && note.length > 0 }>
        <>
          <If isTrue={ shouldShowCoderActions }>
            <>
              <If isTrue={ shouldShowCommentAndQueryButtons }>
                <div className="text-align-center">
                  <span className="m-1-right">
                    <If isTrue={ !shouldRenderReskin2025 }>
                      <Button
                        id="condition-notes-add-query"
                        color="blue"
                        type="submit"
                        onClick={ onSubmitQuery }
                      >
                        Add Query
                      </Button>
                    </If>
                    <If isTrue={ shouldRenderReskin2025 }>
                      <ReveleerButton
                        buttonLabel="Add Query"
                        buttonSize="small"
                        buttonType="primary"
                        id="condition-notes-add-query"
                        isDisabled={ false }
                        onClick={ onSubmitQuery }
                        type="submit"
                      />
                    </If>
                  </span>
                  <span className="m-1-left">
                    <If isTrue={ shouldRenderReskin2025 }>
                      <ReveleerButton
                        buttonLabel="Add Comment"
                        buttonSize="small"
                        buttonType="primary"
                        id="condition-notes-add-comment"
                        isDisabled={ false }
                        onClick={ onSubmitComment }
                        type="submit"
                      />
                    </If>
                    <If isTrue={ !shouldRenderReskin2025 }>
                      <Button
                        id="condition-notes-add-comment"
                        color="blue"
                        type="submit"
                        onClick={ onSubmitComment }
                      >
                        Add Comment
                      </Button>
                    </If>
                  </span>
                </div>
              </If>
              <If isTrue={ !!shouldShowOnlyCommentButton }>
                <div className="text-align-right">
                  <If isTrue={ !shouldRenderReskin2025 }>
                    <Button
                      id="condition-notes-add-comment"
                      color="blue"
                      type="submit"
                      onClick={ onSubmitComment }
                    >
                      Add Comment
                    </Button>
                  </If>
                  <If isTrue={ shouldRenderReskin2025 }>
                    <ReveleerButton
                      buttonLabel="Add Comment"
                      buttonSize="small"
                      buttonType="primary"
                      id="condition-notes-add-comment"
                      isDisabled={ false }
                      onClick={ onSubmitComment }
                      type="submit"
                    />
                  </If>
                </div>
              </If>
            </>
          </If>
          <If isTrue={ shouldShowCdiActions }>
            <div className="text-align-right">
              <If isTrue={ !shouldRenderReskin2025 }>
                <Button
                  id="condition-notes-add-comment"
                  color="blue"
                  type="submit"
                  onClick={ onSubmitComment }
                >
                  Add Comment
                </Button>
              </If>
              <If isTrue={ shouldRenderReskin2025 }>
                <ReveleerButton
                  buttonLabel="Add Comment"
                  buttonSize="small"
                  buttonType="primary"
                  id="condition-notes-add-comment"
                  isDisabled={ false }
                  onClick={ onSubmitComment }
                  type="submit"
                />
              </If>
            </div>
          </If>
        </>
      </If>
    </div>
  )
}

export default connect(mapStateToProps)(ConditionNotes)
